// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company {
  width: 100%;
  height: 100%; }
  .company__tab {
    padding: 15px 8px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    line-height: 150%;
    text-decoration: none;
    transition: all 0.4s; }
    .company__tab span {
      transition: all 0.4s; }
  .company__header {
    display: flex;
    position: relative;
    display: flex;
    gap: 20px; }
    .company__header a {
      text-decoration: none;
      color: #212121; }
    .company__header_active {
      color: #fe6100;
      border-bottom: 3px solid #FE6100; }
    .company__header_noActive {
      color: #212121;
      border-bottom: 3px solid #FFFFFF; }
      .company__header_noActive:active span {
        color: #b62f00; }
      .company__header_noActive:hover {
        background: rgba(254, 97, 0, 0.1);
        border-bottom: 3px solid rgba(254, 97, 0, 0.1); }
        .company__header_noActive:hover span {
          color: #fe6100; }
  .company h1,
  .company h2 {
    font-weight: 600;
    font-size: 32px;
    line-height: 150%;
    color: var(--HightEmphasis);
    padding-bottom: 40px; }
  .company .title {
    font-weight: 600;
    font-size: 32px;
    line-height: 150%;
    color: var(--HightEmphasis);
    margin-bottom: 40px; }
  .company__name {
    margin: 20px 0 70px 0;
    padding: 28px 20px;
    background-color: #ffffff; }
  .company__accounts_tab {
    display: flex;
    justify-content: space-between; }
  .company__accounts_container {
    display: flex;
    flex-direction: column; }
  .company__user {
    margin-top: 34px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e0e0e0;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px; }
    .company__user_admin {
      margin-top: 8px;
      width: fit-content;
      height: 24px;
      padding: 1px 10px;
      background: #ffd1b4;
      border-radius: 2px;
      color: #fe6100;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px; }
    .company__user_worker {
      margin-top: 8px;
      width: fit-content;
      height: 24px;
      padding: 1px 10px;
      background: #dbd4e1;
      border-radius: 2px;
      color: #735b8a;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px; }
    .company__user_superuser {
      margin-top: 8px;
      width: fit-content;
      height: 24px;
      padding: 1px 10px;
      background: #b5f1b9;
      border-radius: 2px;
      color: #ad88cf;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px; }
  .company__add {
    padding: 4px 10px;
    background-color: #fe6100;
    color: #ffffff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    transition: all 0.5s; }
    .company__add:hover {
      background-color: #bf0b0b; }
  .company__key input {
    margin: 10px 10px 10px 0;
    width: 50%;
    height: 51px;
    margin-bottom: 50px;
    border: 1px solid #9e9e9e;
    border-radius: 4px;
    padding: 16px 13px;
    color: #212121;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px; }
    .company__key input:focus {
      border-color: #212121;
      outline: none; }
  .company__key button {
    width: 120px;
    height: 51px;
    padding: 8px 44px;
    text-align: center;
    background: #fe6100;
    border-radius: 4px;
    color: #ffffff;
    border: none;
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
    transition: all 0.5s; }
    .company__key button:hover {
      background: #833505; }
  .company__available {
    margin-bottom: 40px; }
    .company__available h1 {
      margin-bottom: 20px; }
    .company__available_item {
      display: flex;
      gap: 20px;
      font-size: 20px; }

.company_settings {
  height: 95%; }
`, "",{"version":3,"sources":["webpack://./src/pages/company/Company.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,YAAY,EAAA;EAEZ;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,oBAAoB,EAAA;IAPrB;MASG,oBAAoB,EAAA;EAGxB;IACE,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,SAAS,EAAA;IAJV;MAMG,qBAAqB;MACrB,cAAc,EAAA;IAEhB;MACE,cAAc;MACd,gCAAgC,EAAA;IAElC;MACE,cAAc;MACd,gCAAgC,EAAA;MAFjC;QAKK,cAAc,EAAA;MALnB;QASG,iCAAiC;QACjC,8CAA8C,EAAA;QAVjD;UAYK,cAAc,EAAA;EAzCxB;;ICDE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDgDf,2BAA2B;IAC3B,oBAAoB,EAAA;EAlDxB;ICDE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDqDf,2BAA2B;IAC3B,mBAAmB,EAAA;EAErB;IACE,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB,EAAA;EAE3B;IACE,aAAa;IACb,8BAA8B,EAAA;EAEhC;IACE,aAAa;IACb,sBAAsB,EAAA;EAExB;IACE,gBAAgB;IAChB,oBAAoB;IACpB,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;IACjB;MACE,eAAe;MACf,kBAAkB;MAClB,YAAY;MACZ,iBAAiB;MACjB,mBAAmB;MACnB,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IAEnB;MACE,eAAe;MACf,kBAAkB;MAClB,YAAY;MACZ,iBAAiB;MACjB,mBAAmB;MACnB,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IAEnB;MACE,eAAe;MACf,kBAAkB;MAClB,YAAY;MACZ,iBAAiB;MACjB,mBAAmB;MACnB,kBAAkB;MAClB,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;EAGrB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oBAAoB,EAAA;IAVrB;MAYG,yBAAyB,EAAA;EAG5B;IAEG,wBAAwB;IACxB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB,EAAA;IAZpB;MAcK,qBAAqB;MACrB,aAAa,EAAA;EAflB;IAmBG,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,oBAAoB,EAAA;IA9BvB;MAgCK,mBAAmB,EAAA;EAIzB;IACE,mBAAmB,EAAA;IADpB;MAGG,mBAAmB,EAAA;IAErB;MACE,aAAa;MACb,SAAS;MACT,eAAe,EAAA;;AAKrB;EACE,WAAW,EAAA","sourcesContent":["@import '../../styles/media.scss';\n@import '../../styles/fonts.scss';\n.company {\n  width: 100%;\n  height: 100%;\n  \n  &__tab {\n    padding: 15px 8px;\n    cursor: pointer;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 150%;\n    text-decoration: none;\n    transition: all 0.4s;\n    span{\n      transition: all 0.4s;\n    }\n  }\n  &__header {\n    display: flex;\n    position: relative;\n    display: flex;\n    gap: 20px;\n    a{\n      text-decoration: none;\n      color: #212121;\n    }\n    &_active {\n      color: #fe6100;\n      border-bottom: 3px solid #FE6100;\n    }\n    &_noActive {\n      color: #212121;\n      border-bottom: 3px solid #FFFFFF;\n      &:active {\n        span {\n          color: #b62f00;\n        }\n      }\n      &:hover {\n        background: rgba(254, 97, 0, 0.1);\n        border-bottom: 3px solid rgba(254, 97, 0, 0.1);\n        span {\n          color: #fe6100;\n        }\n      }\n    }\n  }\n  h1,\n  h2 {\n    @include h1;\n    color: var(--HightEmphasis);\n    padding-bottom: 40px;\n  }\n  .title {\n    @include h1;\n    color: var(--HightEmphasis);\n    margin-bottom: 40px;\n  }\n  &__name {\n    margin: 20px 0 70px 0;\n    padding: 28px 20px;\n    background-color: #ffffff;\n  }\n  &__accounts_tab {\n    display: flex;\n    justify-content: space-between;\n  }\n  &__accounts_container {\n    display: flex;\n    flex-direction: column;\n  }\n  &__user {\n    margin-top: 34px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid #e0e0e0;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px;\n    &_admin {\n      margin-top: 8px;\n      width: fit-content;\n      height: 24px;\n      padding: 1px 10px;\n      background: #ffd1b4;\n      border-radius: 2px;\n      color: #fe6100;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 24px;\n    }\n    &_worker {\n      margin-top: 8px;\n      width: fit-content;\n      height: 24px;\n      padding: 1px 10px;\n      background: #dbd4e1;\n      border-radius: 2px;\n      color: #735b8a;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 24px;\n    }\n    &_superuser {\n      margin-top: 8px;\n      width: fit-content;\n      height: 24px;\n      padding: 1px 10px;\n      background: #b5f1b9;\n      border-radius: 2px;\n      color: #ad88cf;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 24px;\n    }\n  }\n  &__add {\n    padding: 4px 10px;\n    background-color: #fe6100;\n    color: #ffffff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 24px;\n    transition: all 0.5s;\n    &:hover {\n      background-color: #bf0b0b;\n    }\n  }\n  &__key {\n    input {\n      margin: 10px 10px 10px 0;\n      width: 50%;\n      height: 51px;\n      margin-bottom: 50px;\n      border: 1px solid #9e9e9e;\n      border-radius: 4px;\n      padding: 16px 13px;\n      color: #212121;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 24px;\n      &:focus {\n        border-color: #212121;\n        outline: none;\n      }\n    }\n    button {\n      width: 120px;\n      height: 51px;\n      padding: 8px 44px;\n      text-align: center;\n      background: #fe6100;\n      border-radius: 4px;\n      color: #ffffff;\n      border: none;\n      font-size: 14px;\n      line-height: 24px;\n      cursor: pointer;\n      transition: all 0.5s;\n      &:hover {\n        background: #833505;\n      }\n    }\n  }\n  &__available {\n    margin-bottom: 40px;\n    h1 {\n      margin-bottom: 20px;\n    }\n    &_item {\n      display: flex;\n      gap: 20px;\n      font-size: 20px;\n    }\n  }\n}\n\n.company_settings {\n  height: 95%;\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
